// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"content_breadcrumbs__jjw6k"};